module.exports = __webpack_public_path__ + "img/maruteru_banner.9c71aaeb.jpg";